function scrollAnim(id, transform = "translateY", plus = true, power = 1.01) {
  const target = document.getElementById(id);
  let targetReached = false;

  function updateAnimation() {
    if (targetReached) {
      const scrollAmount2 = window.scrollY * power;
      target.style.transform = `${transform}(${
        plus ? "+" : "-"
      }${scrollAmount2}px)`;
    }
  }

  function handleScroll() {
    targetReached = target.getBoundingClientRect().top < window.innerHeight;
    updateAnimation();
  }

  window.addEventListener("scroll", handleScroll);
}

function initSimpleParallax(selector, options) {
  document.querySelectorAll(selector).forEach((elem) => {
    new simpleParallax(elem, options);
  });
}

function initIntersectionObserver(selector, callback, options = {}) {
  const defaultOptions = {
    root: null,
    threshold: 0.3,
  };
  const observerOptions = { ...defaultOptions, ...options };

  const observer = new IntersectionObserver(callback, observerOptions);

  document.querySelectorAll(selector).forEach((item) => {
    observer.observe(item);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initSimpleParallax(".thumbnail", {
    orientation: "right",
  });

  initSimpleParallax("#right-to-left", {
    orientation: "left",
    scale: "1.1",
    overflow: "true",
  });

  initSimpleParallax("#bottom-to-top", {
    orientation: "up",
    scale: "1.7",
    overflow: "false",
  });

  initSimpleParallax("#bottom-to-top2", {
    orientation: "up",
    scale: "1.8",
    overflow: "false",
  });

  initSimpleParallax("#bottom-to-top3", {
    orientation: "up",
    scale: "1.1",
    overflow: "false",
  });

  initSimpleParallax("#bottom-to-top4", {
    orientation: "up",
    scale: "0.8",
    overflow: "false",
  });

  initSimpleParallax("#bottom-to-top5", {
    orientation: "up",
    scale: "1.3",
    overflow: "false",
  });

  scrollAnim("scrolling-up-anim", "translateY", false, 0.1);
  scrollAnim("scrolling-up-anim2", "translateY", false, 0.2);

  initSimpleParallax("#scrolling-up-anim3", {
    orientation: "up",
    scale: "1.9",
    overflow: "true",
  });

  initSimpleParallax("#scrolling-up-anim4", {
    orientation: "up",
    scale: "1.4",
    overflow: "true",
  });

  initIntersectionObserver(".item-container", (entries, observer) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        const delay = index * 0.3;
        entry.target.style.transitionDelay = `${delay}s`;
        entry.target.classList.add("visible");
      }
    });
  });

  initIntersectionObserver(".slide-lr-anim", (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("slide-lr-img");
        observer.unobserve(entry.target);
      }
    });
  });

  initIntersectionObserver(".slide-up-anim", (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("slide-up-img");
        observer.unobserve(entry.target);
      }
    });
  });

  initIntersectionObserver(".slide-rl-anim", (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("slide-rl-img");
        observer.unobserve(entry.target);
      }
    });
  });

  var footerElement = document.getElementById("shopify-section-footer");
  if (footerElement) {
    footerElement.style.position = "relative";
    footerElement.style.top = "-10px";
  }
});
